import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchOpenings } from '../actions/openings'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import OpeningsList from '../components/OpeningsList'

import OpeningsFilterForm from '../forms/OpeningsFilterForm'

import '../styles/OpeningsView.css'

class OpeningsView extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const today = new Date().toISOString().substring(0, 10)
    this.props.fetchOpenings('', '', today, today)
  }

  renderOpenings() {
    const { openings, error, loading } = this.props

    if (error) {
      return <ErrorMessage message={error.message} />
    }

    if (!openings || loading) {
      return <LoadingProgress />
    }

    return <OpeningsList openings={openings} />
  }

  render() {
    const { openings, loading } = this.props
    const count = (!loading && openings) ? openings.length : null

    return (
      <div className="openings-view">

        {/* ── Header ── */}
        <div className="openings-header">
          <div className="openings-header-content">
            <div className="openings-header-text">
              <h1>
                <i className="fas fa-door-open"></i>
                <span className="text-vw-dark">Aperturas</span>
              </h1>
              <p className="openings-subtitle">Registro de aperturas remotas de taquillas</p>
            </div>
            {count !== null && (
              <div className="openings-header-badge">
                <span className="openings-count-badge">{count} registros</span>
              </div>
            )}
          </div>
        </div>

        {/* ── Filter card ── */}
        <div className="openings-filter-card">
          <div className="openings-section-header">
            <i className="fas fa-filter"></i> Filtros
          </div>
          <div className="openings-section-body">
            <OpeningsFilterForm />
          </div>
        </div>

        {/* ── Results card ── */}
        <div className="openings-section-card">
          <div className="openings-section-header">
            <i className="fas fa-list"></i> Registros
          </div>
          <div className="openings-section-body p-0">
            {this.renderOpenings()}
          </div>
        </div>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  openings: state.openings.openings,
  error: state.openings.error,
  loading: state.openings.loading,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchOpenings: bindActionCreators(fetchOpenings, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OpeningsView)


